import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
//#region src/properties/usePropertiesInPolygonQuery.ts
var r = (r, i) => t({
	queryKey: e.polygon(r, i),
	queryFn: () => n.getPropertiesInPolygon(r, i),
	enabled: !!r
});
//#endregion
export { r as usePropertiesInPolygonQuery };
